import { defineStore } from 'pinia'

export const ErrorStore = defineStore('err_store', {
    state: () => {
        return { err_store: [] }
    },
    actions: {
        get() {
            return this.err_store
        },
        set(value) {
            this.err_store = value
        }
    },
})